import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import { StationsState, StationsPricesReportFilter } from '../../types';

export const getStationsPriceReport = createReduxAsyncThunk<
  StationsState['stationsPriceReport']['data'],
  StationsPricesReportFilter
>(
  `${STATIONS_STATE}/getStationsPriceReport`,
  async (filter) => {
    const { data } = await stationsAPI.getStationsPriceReport(filter);
    return data;
  }
);
